export default class StreamProfileService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntity(id, params) {
		return this.apiService.callGet('streamProfiles/' + id, params)
	}

	getEntities(params) {
		return this.apiService.callGet('streamProfiles', params)
	}

	createEntity(params) {
		return this.apiService.callPost('streamProfiles', params)
	}

	updateEntity(id, params) {
		return this.apiService.callPut('streamProfiles/' + id, params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('streamProfiles/' + id, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/StreamProfileService.js